export default __webpack_public_path__ + "static/media/reading-icon.8201a37da167145df9610c8261546e06.svg";